import { objComparatorNumber } from "../utils.js";
import axios from 'axios';
import { endpoint, remoteCreate, remoteModifyPut } from "./utils.js";

export function moneyDestRootURL() {
  return endpoint("internal/current/moneydestinations/");
}

export async function fetchMoneyDests() {
  const res = await axios.get(moneyDestRootURL(), {
    withCredentials: true
  });
  return res.data.sort((a, b) => objComparatorNumber(a, b, 'id')).map(el => {
    return { ...el, visual_name: `${el['id']} - ${el['society_name']}` };
  });
}

export async function createMoneyDest(useAlerts, payload) {
  await remoteCreate(useAlerts, moneyDestRootURL(), payload, 'Money Destination', 'MD');
}

export async function modifyPutMoneyDest(useAlerts, payload, moneyDestId) {
  await remoteModifyPut(useAlerts, `${moneyDestRootURL()}${moneyDestId}/`, payload, 'Money Destination', 'MD');
}
